import { FunctionComponent, useCallback } from 'react'
import { RoundedButton } from '../../../shared'
import { PatientInformationsActionButtonsProps } from './PatientInformationsActionsButtons.model'
import styles from './PatientInformationsActionButtons.module.scss'

export const PatientInformationsActionButtons: FunctionComponent<
  PatientInformationsActionButtonsProps
> = ({
  groupId,
  search,
  showNewPatientInformationsForm,
  hasResults,
  isEditingPatientInformations,
  hasPendingData,
  onBackButtonClick,
  onValidPatientInformations,
  onShowAddPatientInformationsForm,
}) => {
  const handleShowAddPatientInformationsForm = useCallback(
    () => onShowAddPatientInformationsForm(undefined, search),
    [onShowAddPatientInformationsForm, search],
  )

  return (hasResults && groupId) || showNewPatientInformationsForm ? (
    <div className={styles.patientInformationsButtonsContainer}>
      <RoundedButton
        theme="light"
        label={isEditingPatientInformations ? 'Annuler' : 'Retour'}
        size="micro"
        onClick={onBackButtonClick}
        testId={`button-patient_allergy-${isEditingPatientInformations ? 'cancel' : 'return'}`}
      />
      {showNewPatientInformationsForm && (
        <RoundedButton
          theme="primary"
          label="Enregistrer"
          size="micro"
          onClick={onValidPatientInformations}
          testId="button-patient_allergy-save"
          disabled={hasPendingData}
        />
      )}
    </div>
  ) : (
    <RoundedButton
      label="Ajouter manuellement"
      size="micro"
      onClick={handleShowAddPatientInformationsForm}
      testId="button-patient_allergy-manually-add"
    />
  )
}
